import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { PitchTitleIcon } from 'sections/Benefits/svg';
import styles from 'sections/Benefits/Support/components/SectionPitch/SectionPitch.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>
        <div className={cn('pitch__title-box')}>
          <h2 className={cn('pitch__title')}>
            {PitchTitleIcon}
            Here to Support Your Success at Every Step
          </h2>
          <p className={cn('pitch__title-description')}>
            Logistics is complex—we simplify it with our unparalleled support system, 
            giving freight forwarders the confidence to tackle every challenge.
          </p>
        </div>
        <div className={cn('pitch__paragraphs')}>
          <p className={cn('pitch__paragraph')}>
            At DFA, we understand that the logistics industry is demanding and ever-evolving. 
            That’s why our support system is designed to empower freight forwarders with 
            the expertise, tools, and resources they need to excel. From instant responses 
            to your queries to hands-on assistance with any operational hurdle, we ensure 
            that you’re never left to face challenges alone. With 24/7 global support and a 
            team that knows the freight forwarding business inside-out, you gain access to 
            solutions that are prompt, effective, and tailored to your business needs.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionPitch;